// NOTE: DueDate arrives inconsistently from the backend — sometimes in seconds,
// sometimes in milliseconds. The threshold detects which unit is used.
// TODO: Remove this workaround once the protocol is fixed to always use one unit.
export const toDateFromUnixLikeValue = (value: bigint) => {
  const numericValue = Number(value);
  const normalizedTimestamp =
    numericValue > 1_000_000_000_000 ? numericValue : numericValue * 1000;

  return new Date(normalizedTimestamp);
};
